import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Notification, AppState } from './types'

const INITIAL_STATE: AppState = {
  notification: {
    text: '',
    type: 'info',
  },
  openModal: false,
}

const slice = createSlice({
  name: 'app',
  initialState: INITIAL_STATE,
  reducers: {
    updateNotification(state: AppState, action: PayloadAction<Notification>) {
      const { text, type } = action.payload

      state.notification = { text, type }
    },
    clearNotification(state: AppState) {
      state.notification = { text: '', type: 'info' }
    },
    handleToggleModal(state: AppState, action: PayloadAction<any>) {
      state.openModal = action.payload.openModal
    },
  },
})

export const { updateNotification, clearNotification, handleToggleModal } =
  slice.actions

export default slice.reducer
